export default __webpack_public_path__ + "static/media/nv7.ebdefcd4.PNG";